export const applyQueryTokens = (pattern, values) => {
  const valueKeys = Object.keys(values)
  return valueKeys.reduce(
    (adjustedPattern, valueKey) => applyQueryToken(adjustedPattern, valueKey, values[valueKey]),
    pattern,
  ).replace(/\{(\s|\S)+?\}/g, '')
}

export const applyQueryToken = (pattern, name, value) => {
  console.log('applyQueryToken')
  console.log(pattern)
  console.log(name)
  console.log(value)
  const nameToken = `{&${name}}`
  const valueToken = `{${name}}`
  if (value === '' || (typeof value === 'undefined ')) {
    return pattern.replace(nameToken, '').replace(valueToken, '')
  }
  const separator = pattern.includes('?') ? '&' : '?'
  return (pattern
    .replace(nameToken, `${separator}${name}=${encodeURIComponent(value)}`)
    .replace(valueToken, encodeURIComponent(value))
  )
}

export const applyQuerySeparator = (prepend, append) => {
  if (prepend.includes('?')) {
    return `${prepend}${append}`
  }
  return `${prepend}${append.replace('&', '?')}`
}
